module.exports = __webpack_public_path__ + "static/media/icon_user.f9b9e61d.svg";